// src/components/JarvislyModule/PageHeader/CardHeaderIcons.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import SimpleIcons from 'components/SimpleComponents/SimpleIcons';
import { DeleteOutlined, EditOutlined } from '@ant-design/icons';
import { getFlag } from 'utils/phone';
import translateX from 'utils/translateX';

// *******************************************************************************
// CONSTANTS
// *******************************************************************************

// *******************************************************************************
// MAIN COMPONENT
// *******************************************************************************
export const CardHeaderIcons = ({ record, countryCode }) => {
  if (!countryCode) return null;

  // Add country flag icon if countryCode is provided
  const flagUrl = getFlag(countryCode, false); // Get SVG URL

  if (!flagUrl) return null;

  const icons = [
    {
      key: 'country',
      icon: (
        <img
          src={flagUrl}
          alt={countryCode}
          style={{
            // width: 16,
            height: 14, // 3:2 aspect ratio (16*0.67 ≈ 11)
            objectFit: 'cover',
            borderRadius: 2,
            display: 'inline-block',
            verticalAlign: 'middle',
          }}
        />
      ),
      tooltipText: translateX('document_profile'),
      onClick: null, // No action, just display
    },
  ];

  return <SimpleIcons align="start" items={icons?.filter(i => i?.icon)} />;
};

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default CardHeaderIcons;

// *******************************************************************************
// HELPERS
// *******************************************************************************
